import { VStack, Table, Thead, Tr, Th, Tbody, Td, Text, Link } from '@chakra-ui/react';
import { Payment } from './types';

export const PaymentHistory = ({ payments }: { payments: Payment[] }) => (
  <VStack spacing={4} align="stretch">
    {payments.length > 0 ? (
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>Amount</Th>
            <Th>Status</Th>
            <Th>Customer Email</Th>
            <Th>Receipt</Th>
          </Tr>
        </Thead>
        <Tbody>
          {payments.map((payment) => (
            <Tr key={payment.id}>
              <Td>{new Date(payment.paidOn).toLocaleDateString()}</Td>
              <Td>{`$${(payment.amount / 100).toFixed(2)} ${payment.currency.toUpperCase()}`}</Td>
              <Td>
                <Text
                  fontWeight="bold"
                  color={payment.status === 'paid' ? 'green.500' : 'red.500'}
                >
                  {payment.status.charAt(0).toUpperCase() + payment.status.slice(1)}
                </Text>
              </Td>
              <Td>{payment.customerEmail}</Td>
              <Td>
                {payment.receiptUrl ? (
                  <Link href={payment.receiptUrl} isExternal color="blue.500">
                    Download
                  </Link>
                ) : (
                  'N/A'
                )}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    ) : (
      <Text textAlign="center" color="gray.500">
        No previous payments yet.
      </Text>
    )}
  </VStack>
);
